<div>
  <mat-card>
    <mat-card-content style="text-align: end;">
      <mat-hint style="color: red;">{{status}} </mat-hint>
      @if (showDeactivateToggle && id.value) {
        <mat-slide-toggle (change)="openDeactivateForm($event)" [(ngModel)]="checked">Deactivate</mat-slide-toggle>
      }
      @if (showReactivateToggle && id.value) {
        <mat-slide-toggle (change)="openReactivateForm($event)" [(ngModel)]="checked">Reactivate</mat-slide-toggle>
      }
    </mat-card-content>
    <form [formGroup]="verticalForm">
      <mat-card-content>
        <mat-form-field appearance="fill">
          <mat-label>Code</mat-label>
          <input matInput formControlName="code" placeholder="Code" required>
          @if (code.touched && code.invalid && code.hasError('required')) {
            <mat-error>
              Code is required
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Name</mat-label>
          <input matInput formControlName="name" placeholder="Name" required>
          @if (name.touched && name.invalid && name.hasError('required')) {
            <mat-error>
              Name is required
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Alias</mat-label>
          <mat-chip-grid #chipList>
            @for (alias of getAliases(); track alias; let i = $index) {
              <mat-chip-row [removable]="true" (removed)="removeAlias(i)">
                {{alias.name}}
                @if (true) {
                  <mat-icon matChipRemove>cancel</mat-icon>
                }
              </mat-chip-row>
            }
            <input placeholder="Add Alias...." autocomplete="off" [matChipInputFor]="chipList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes" [matChipInputAddOnBlur]="true"
              (matChipInputTokenEnd)="addAlias($event)" maxlength="50"/>
            </mat-chip-grid>
          </mat-form-field>
        </mat-card-content>
        <mat-card-actions>
          <button mat-button color="primary" [disabled]="(!editPermission && id.value) || (!addPermission && !id.value)" (click)="save()" style="width: 10%;margin-right: 10px;">Save</button>
          <button mat-button color="cancel" (click)="cancel()" style="width: 10%;">Cancel</button>
        </mat-card-actions>
        <mat-card-content style="margin-top: 3%;">
          @if (id.value) {
            <div class="audit-log">
              <button mat-stroked-button type="button" [class.active]="viewLog.value"
                  (click)="viewLog.setValue(!viewLog.value)">
                  <mat-icon>history</mat-icon> View Log
              </button>
            </div>
          }
          @if (viewLog.value) {
            <app-history [referenceType]="'VERTICAL'" [referenceId]="id.value"></app-history>
          }
        </mat-card-content>
      </form>
    </mat-card>
  </div>
